<h1>{{ title() }}</h1>
<p>{{ message() }}</p>

@if(code() === 'unauthorized')
{
    <p>You do not have permission to access this page.</p>
    <button nz-button nzType="default" (click)="auth.logout()">Wyloguj</button>
}